<template>
  <div>
    <sectors-table :sortable="false" class="mt-5" @delete="detachRevisedSector" @refresh="getUserRevisedSectors"
      icon="mdi-puzzle"
      color="orange darken-1"
      header-color="text-tertiary"
      :title="$t('Pages.Sectors.revised_sectors')"
      hide-show-btn
      hide-edit-btn
      hide-search
      hide-subtitle
      :hide-actions="!hasRole(UserRoles.ADMIN)"
      :total="total"
      :items="userRevisedSectors"
      :pagination="pagination">
        <v-tooltip top slot="add" v-if="hasRole(UserRoles.ADMIN)">
          <v-btn slot="activator" small right fab dark color="tertiary lighten-1" @click.stop="openAttachSectorModal(true)">
            <v-icon dark>add</v-icon>
          </v-btn>
          <span>{{$t('Pages.Users.attach_sector')}}</span>
        </v-tooltip>
    </sectors-table>
    <attach-sector-modal @refresh="getUserRevisedSectors" v-model="showAttachSectorModal" :userId="this.$route.params.id" @close="showAttachSectorModal = false" :is-reviser="isReviser"></attach-sector-modal>
  </div>
</template>

<script>
  import _ from 'lodash';
  import AttachSectorModal from './AttachSectorModal'
  import SectorsTable from '../sectors/Table'
  import i18n from '@/i18n'
  export default {
  components: {AttachSectorModal, SectorsTable},
  data: () => ({
    showAttachSectorModal: false,
    isReviser: false,
    userRevisedSectors: [],
    initial: true,
    total: 0,
    pagination: {},
    appendHeaders: [
      {
        sortable: false,
        text: i18n.t('Pages.Users.model.started_working'),
        value: 'started_working',
        align: 'center'
      },
      {
        sortable: false,
        text: i18n.t('Pages.Workplaces.title_singular'),
        value: 'workplace.name',
        align: 'right'
      },
    ]
  }),
  computed: {

  },
  created () {

  },
  methods: {
    getUserRevisedSectors(data = null){
      this.pagination = data;
      if(this.initial){
        this.setFetching(true);
      }
      this.loading = true;
      this.repositories.user.getRevisedSectors(this.$route.params.id, null, data).then(response => {
        this.userRevisedSectors = response.data.data;
        this.total = response.data.meta.pagination.total;
      }).finally(() => {
        this.loading = this.initial = false;
        this.setFetching(false);
      });
    },
    openAttachSectorModal(isReviser){
      this.isReviser = isReviser;
      this.showAttachSectorModal = true;
    },
    detachRevisedSector(item){
      this.repositories.user.detachRevisedSector(this.$route.params.id, item.id).then((response) => {
        this.$toast.info(response.data.message);
      this.getUserRevisedSectors();
    });
    },
  }
}
</script>

<style lang="scss">

</style>
